import { render, staticRenderFns } from "./Employee.vue?vue&type=template&id=ff7224d4&scoped=true"
import script from "./Employee.vue?vue&type=script&lang=ts"
export * from "./Employee.vue?vue&type=script&lang=ts"
import style0 from "./Employee.vue?vue&type=style&index=0&id=ff7224d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7224d4",
  null
  
)

export default component.exports